<ng-container *transloco="let t">
  <div [formGroup]="form">
    <div formGroupName="fipTestResult" class="group-block">
      <h3 class="group-title">{{ t('fipTestTitle') }}</h3>
      <div class="group-inputs">
        <mat-form-field appearance="outline" class="w-full">
          <mat-label>{{ t('fipTestTitle') }} </mat-label>
          <textarea
            matInput
            [formControlName]="currentLang"
            rows="4"
          ></textarea>
        </mat-form-field>
      </div>
    </div>
    <div formGroupName="note" class="group-block">
      <h3 class="group-title">{{ t('note') }}</h3>
      <div class="group-inputs">
        <mat-form-field appearance="outline" class="w-full">
          <mat-label>{{ t('note') }}</mat-label>
          <textarea
            matInput
            [formControlName]="currentLang"
            rows="4"
          ></textarea>
        </mat-form-field>
      </div>
    </div>

    <mat-form-field appearance="outline" class="w-full mb-3">
      <mat-label>{{ t('veterinarianName') }}</mat-label>
      <input matInput formControlName="veterinarianName" />
      <mat-error>{{ t('This field is required') }}</mat-error>
    </mat-form-field>
  </div>
</ng-container>
